import React from 'react';
import BasePrintings from "@/components/Common/Printings";
import { AVAILABLE_MODE } from "@/libs/AuditTrailOperations";

const Printings = () => <BasePrintings mode={AVAILABLE_MODE.OUT} />;

export default Printings;
